import { IS_INSTALLED } from '@/lib/detection';

const ENDORSELY_ORG_ID = import.meta.env.VITE_ENDORSELY_ORG_ID;

/**
 * Endorsely script to track referrals to inject in appropriate pages
 */
export function EhEndorselyScript() {
  if (!ENDORSELY_ORG_ID || IS_INSTALLED || import.meta.env.DEV) return null;

  return (
    <script async src="https://assets.endorsely.com/endorsely.js" data-endorsely={ENDORSELY_ORG_ID}></script>
  );
}
